module.exports = __webpack_public_path__ + "img/index_kyzx_rgzn.adf8bda0.png";